module.exports = __webpack_public_path__ + "web_static/img/green_squiggle_animation.23356ac5.gif";